module.exports = __webpack_public_path__ + "img/yiduiyi01.f6dce9ce.jpg";